'use memo';

import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client';
import { TaskModalPageProps } from '../TaskModalPageProps';
import QldAgreementCommissionPage from './QldAgreementCommissionPage';

const AgreementCommissionPage = (props: TaskModalPageProps) => {
  switch (props.campaign.state) {
    case CampaignDetailModelState.QLD:
      return <QldAgreementCommissionPage {...props} />;
    default:
      return null;
  }
};

export default AgreementCommissionPage;
